import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllServiceOccurrences = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/service-occurrences',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveServiceOccurrence = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/service-occurrences',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateServiceOccurrence = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/service-occurrences/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteServiceOccurrence = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/service-occurrences/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllServiceOccurrences,
  saveServiceOccurrence,
  deleteServiceOccurrence,
  updateServiceOccurrence,
}
